import React, { useState, useEffect } from 'react'
import { useSmoothScroll } from '../hooks/useSmoothScroll'

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [activeSection, setActiveSection] = useState('home')
  
  const scrollToSection = useSmoothScroll()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
      
      const sections = ['hero', 'about', 'values', 'services', 'jobs', 'contact']
      const navbarHeight = 120
      
      for (const section of sections) {
        const element = document.getElementById(section)
        if (element) {
          const { offsetTop, offsetHeight } = element
          if (window.scrollY >= offsetTop - navbarHeight && 
              window.scrollY < offsetTop + offsetHeight - navbarHeight) {
            setActiveSection(section)
            break
          }
        }
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { href: '#hero', text: 'Home' },
    { href: '#about', text: 'About' },
    { href: '#values', text: 'Values' },
    { href: '#services', text: 'Services' },
    { href: '#jobs', text: 'Jobs' },
    { href: '#contact', text: 'Contact' }
  ]

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const handleNavLinkClick = (href) => {
    scrollToSection(href)
    setIsMobileMenuOpen(false)
  }

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          {/* Logo */}
          <a href="#hero" className="navbar-logo" onClick={(e) => { e.preventDefault(); handleNavLinkClick('#hero'); }}>
            <i className="fas fa-house-chimney"></i>
            <span className="logo-green">Talent</span>
            <strong>House</strong>
          </a>

          {/* Desktop Navigation */}
          <div className="nav-links">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`nav-link ${activeSection === link.href.slice(1) ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); handleNavLinkClick(link.href); }}
              >
                {link.text}
              </a>
            ))}
            <button 
              className="btn btn-primary"
              onClick={() => handleNavLinkClick('#contact')}
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="hamburger"
            aria-label="Toggle navigation"
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-nav"
            onClick={handleMobileMenuToggle}
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div id="mobile-nav" className={`mobile-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`mobile-nav-link ${activeSection === link.href.slice(1) ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); handleNavLinkClick(link.href); }}
            >
              {link.text}
            </a>
          ))}
          <button 
            className="btn btn-primary"
            onClick={() => handleNavLinkClick('#contact')}
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
